module.exports = __webpack_public_path__ + "8c9a02ccbd88800eb10ab38770b2d9f4.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-6.cur
// module id = 467
// module chunks = 0